/**
 * @file Form
 */

/**
 * Form component
 */
const vForm = () => {
    const form = document.querySelector('.v-form');

    if (!form) {
        return;
    }

    const formElement      = document.querySelector('form');
    const dynamicInput     = form.querySelector('.v-form__field-icon.has-icons-right');
    const referralInput    = form.querySelector('select[name="referral"]');
    const pregnancyInputs    = form.querySelectorAll('input[name="is_pregnant"]');
    const tobaccoInputs    = form.querySelectorAll('input[name="tobacco_use"]');
    const noInsuranceInput = form.querySelector('input[name="no_insurance"]');
    const requiredInputs   = form.querySelectorAll('[required]');
    const premedChecks     = form.querySelectorAll('.v-form__field-input--premed input[type="checkbox"]');
    let errorCount         = 0;

    /**
     * Add dynamic input
     */
    const addInput = (e) => {
        e.preventDefault();
        const { target } = e;
        const button     = target.closest('button');
        const { parentNode } = button;
        const inputElement = parentNode.cloneNode(true);

        inputElement.querySelector('input').value = '';
        dynamicInput.parentNode.insertBefore(inputElement, parentNode.nextSibling);
        parentNode.removeChild(button);
        parentNode.classList.remove('has-icons-right');
        inputElement.querySelector('button').addEventListener('click', addInput);
        inputElement.querySelector('input').placeholder = inputElement.getAttribute('data-ph') + ' ' + (dynamicInput.parentNode.childElementCount - 1);
        inputElement.querySelector('input').focus();
    };

    /**
     * Toggles visibility of conditional fields
     */
    const toggleVisiblity = (elem, visible = true) => {
        if (visible) {
            elem.removeAttribute('hidden');
        } else {
            elem.setAttribute('hidden', '');
        }
    };

    /**
     * Referral input change handler
     *
     */
    const referralChangeHandler = () => {
        const referralConditional = form.querySelector('.v-form__field--referral-conditional');
        const { options } = referralInput;
        const { selectedIndex } = referralInput;
        toggleVisiblity(referralConditional, options[selectedIndex].classList.contains('has-other'));
    }

    if (dynamicInput) {
        const addBtn = dynamicInput.querySelector('button');

        addBtn.addEventListener('click', addInput);
    }

    if (referralInput) {
        referralInput.addEventListener('change', referralChangeHandler);
        referralChangeHandler();
    }

    if (pregnancyInputs) {
        const pregnancyConditional = form.querySelector('.v-form__field--is_pregnant-conditional');

        [...pregnancyInputs].forEach((input) => {
            input.addEventListener('change', (e) => {
                const { target } = e;
                toggleVisiblity(pregnancyConditional, target.value === 'y');
            });

            if (input.checked && input.value === 'y') {
                toggleVisiblity(pregnancyConditional, true);
            }
        });
    }

    if (tobaccoInputs) {
        const tobaccoConditional = form.querySelector('.v-form__field--tobacco-conditional');

        [...tobaccoInputs].forEach((input) => {
            input.addEventListener('change', (e) => {
                const { target } = e;
                toggleVisiblity(tobaccoConditional, target.value === 'y');
            });

            if (input.checked && input.value === 'y') {
                toggleVisiblity(tobaccoConditional, true);
            }
        });

    }

    if (noInsuranceInput) {
        const parentFieldset    = noInsuranceInput.closest('.v-form__fieldset');
        const conditionalFields = parentFieldset.querySelectorAll('.v-form__field:not(.v-form__field--no-insurance)');

        /**
         * Toggles conditional fields
         * @param {boolean} visible - Whether to show or hide the fields
         */
        const toggleConditionalFields = (visible = true) => {
            [...conditionalFields].forEach((field) => {
                const inputs = field.querySelectorAll('input, select, textarea');
                [...inputs].forEach((input) => {
                    if ( visible ) {
                        input.removeAttribute('disabled');
                    } else  {
                        input.value = '';
                        input.setAttribute('disabled', '');
                    }
                });
            });
        };

        noInsuranceInput.addEventListener('change', (e) => {
            const { target } = e;
            toggleConditionalFields(!target.checked);
        });

        if (noInsuranceInput.checked) {
            toggleConditionalFields(false);
        }
    }

    if (premedChecks.length) {
        [...premedChecks].forEach((check) => {
            const premedConditional = check.parentElement.nextElementSibling;

            check.addEventListener('change', (e) => {
                const { target } = e;
                toggleVisiblity(premedConditional, target.checked);
            });

            if (check.checked) {
                toggleVisiblity(premedConditional, true);
            }
        });
    }

    formElement.addEventListener('submit', (e) => {
        e.preventDefault();
        const { target } = e;
        const formData = new FormData(target);

        [...requiredInputs].forEach((input) => {
            if (input.type === 'radio' && !formData.get(input.name)) {
                const wrapper = input.closest('.v-form__field-input');
                wrapper.classList.add('v-form__radio-error');
                input.setAttribute('data-focus', '');
                errorCount++;
            } else if (input.type === 'select-one' && !input.value) {
                const wrapper = input.closest('.v-form__field');
                input.setAttribute('data-focus', '');
                wrapper.classList.add('is-danger');
                errorCount++;
            } else if (input.type !== 'radio' && !input.value) {
                input.classList.add('is-danger');
                input.setAttribute('data-focus', '');
                errorCount++;
            }
        });


        if (premedChecks.length) {
            [...premedChecks].forEach((check) => {
                const inputName = check.getAttribute('name');
                const premedConditional = check.closest('.v-form__field-input').querySelector(`input[name="${inputName}_date"]`);
                if (check.checked && !premedConditional.value) {
                    premedConditional.classList.add('is-danger');
                    check.setAttribute('data-focus', '');
                    errorCount++;
                }
            });
        }

        if (errorCount > 0) {
            const errorsList = form.querySelectorAll('[data-focus]');
            const firstError = errorsList[0];
            console.log(firstError);
            window.scrollTo(firstError.getBoundingClientRect().left, firstError.getBoundingClientRect().top);
            firstError.focus();
            [...errorsList].forEach((error) => {
                error.removeAttribute('data-focus');
            });
            errorCount = 0;
            return;
        }

        formElement.submit();
    });

    [...requiredInputs].forEach((input) => {
        input.addEventListener('change', () => {
            if (input.type === 'radio') {
                const wrapper = input.closest('.v-form__field-input');
                wrapper.classList.remove('v-form__radio-error');
            } else if (input.type === 'select-one') {
                const wrapper = input.closest('.v-form__field');
                wrapper.classList.remove('is-danger');
            } else {
                input.classList.remove('is-danger');
            }
        });
    });

    if (premedChecks.length) {
        [...premedChecks].forEach((check) => {
            const inputName = check.getAttribute('name');
            const premedConditional = check.closest('.v-form__field-input').querySelector(`input[name="${inputName}_date"]`);
            premedConditional.addEventListener('change', () => {
                premedConditional.classList.remove('is-danger');
            });
        });
    }
};

export default vForm;
